import axios from 'axios'
import constants from '../../../helpers/constants'
import { isEqual } from '@/helpers/isEqual'

export default {
  state: {
    contactsFormData: {
      name: '',
      lastName: '',
      fatherName: '',
      email: '',
      city: null,
      recipientName: '',
      recipientFatherName: '',
      recipientLastName: '',
      recipientPhone: ''
    },
    invalidFields: {},
    deliveryCities: [],
    isContactFormHidden: false,
    deliveryTypes: [],
    isContactFormEmpty: false,
    lastSelectedCity: null
  },
  getters: {
    isContactFormValid (state, getters, rootState) {
      const { name, lastName, fatherName, city, email } = state.invalidFields
      const { contactsFormData } = state

      if (constants.IS_MANAGER_CHECKOUT && rootState.checkout.formData?.paymentType === '3') {
        return (
          !name &&
          !lastName &&
          !fatherName &&
          !city &&
          !email &&
          !!(contactsFormData.name && contactsFormData.city?.id && contactsFormData.lastName && contactsFormData.fatherName && contactsFormData.email)
        )
      }
      return (
        !name &&
        !lastName &&
        !fatherName &&
        !city &&
        !email &&
        !!(contactsFormData.name && contactsFormData.city?.id && contactsFormData.lastName && contactsFormData.fatherName)
      )
    }
  },
  mutations: {
    SET_CONTACTS_FORM (state, data) {
      state.contactsFormData = { ...state.contactsFormData, ...data }
    },
    SET_INVALID_FIELDS (state, data) {
      state.invalidFields = { ...state.invalidFields, ...data }
    },
    SET_IS_CONTACT_FORM_HIDDEN: (state, data) => {
      state.isContactFormHidden = data
    },
    SET_DELIVERY_TYPES: (state, data) => {
      state.deliveryTypes = data
    },
    SET_DELIVERY_CITIES: (state, cities) => {
      state.deliveryCities = cities
    },
    SET_CONTACT_FORM_EMPTY: (state, bool) => {
      state.isContactFormEmpty = bool
    },
    SET_LAST_SELECTED_CITY (state, cityId) {
      state.lastSelectedCity = cityId
    }
  },
  actions: {
    SET_CONTACTS_FULL_NAME_ACTION ({ commit, dispatch }, data) {
      const { value, inputType } = data
      const info = {}

      info[inputType] = value
      commit('SET_CONTACTS_FORM', info)
      dispatch('VALIDATE_NAME_AND_LAST_NAME', { value, inputType })
    },
    VALIDATE_NAME_AND_LAST_NAME ({ commit, rootGetters }, { value, inputType }) {
      const { translations } = rootGetters

      const regSpec = new RegExp('[!@#№/$%^&*(),.?":;_=+{}|<>]')
      const regLatin = new RegExp(/[a-z]/i)
      const regRus = new RegExp(/[ъыёэ]/i)
      const regNum = new RegExp(/\d/)
      const regSpace = new RegExp(/\s/g)
      const regIsLetterExclude = new RegExp(/[^а-яїіёєґ`‘’'/-]/i)
      const regApostrophes = new RegExp(/[`‘’']/g)
      let error = ''
      const trimmedValue = value.replace(regSpace, '')
      const valueWithoutApostrophes = value.replace(regApostrophes, '')

      if (/^-+$/.test(value)) {
        error = translations('blank_field_error')
      }
      if (regIsLetterExclude.test(value)) {
        error = translations('blank_field_error')
      }
      if (regSpace.test(value)) {
        error = translations('field_contains_space')
      }
      if (regLatin.test(value)) {
        error = translations('field_contains_latin_letter')
      }
      if (regRus.test(value)) {
        if (inputType === 'name' || inputType === 'recipientName') {
          error = translations('name_contains_rus_letters')
        } else if (inputType === 'lastName' || inputType === 'recipientLastName') {
          error = translations('last_name_contains_rus_letters')
        } else if (inputType === 'fatherName' || inputType === 'recipientFatherName') {
          error = translations('father_name_contains_rus_letters')
        }
      }
      if (regNum.test(value)) {
        error = translations('field_contains_numbers')
      }
      if (regSpec.test(value) || (trimmedValue.match('--') && trimmedValue.match('--').length)) {
        error = translations('field_contains_special_characters')
      }
      if (
        value.match(regApostrophes) &&
        (value.match(regApostrophes).length > 2 || valueWithoutApostrophes.length < 2)
      ) {
        error = translations('field_contains_special_characters')
      }

      const currentInputError = {}
      currentInputError[inputType] = error

      commit('SET_INVALID_FIELDS', currentInputError)
    },
    SET_CONTACTS_FORM_FIELDS_FROM_SERVER ({ commit, dispatch, rootState, state }, userData) {
      const { name, last_name: lastName, father_name: fatherName, email, phone } = userData
      const { contactsFormData } = state

      if (name && !contactsFormData.name) dispatch('SET_CONTACTS_FULL_NAME_ACTION', { value: name, inputType: 'name' })
      if (lastName && !contactsFormData.lastName) {
        dispatch('SET_CONTACTS_FULL_NAME_ACTION', { value: lastName, inputType: 'lastName' })
      }
      if (fatherName && !contactsFormData.fatherName) {
        dispatch('SET_CONTACTS_FULL_NAME_ACTION', { value: fatherName, inputType: 'fatherName' })
      }
      if (email && !contactsFormData.email) commit('SET_CONTACTS_FORM', { email })
      if (phone && !contactsFormData.phone) dispatch('SET_FORM_DATA', { phone: phone.substring(3, 12) }, { root: true })
    },
    SET_CONTACTS_FORM_FIELDS_FROM_STORAGE ({ commit, dispatch, rootState }) {
      const { formData } = rootState.checkout
      const { name, lastName, fatherName, city, email, recipientName, recipientFatherName, recipientLastName, recipientPhone } = formData

      if (name) dispatch('SET_CONTACTS_FULL_NAME_ACTION', { value: name, inputType: 'name' })
      if (lastName) dispatch('SET_CONTACTS_FULL_NAME_ACTION', { value: lastName, inputType: 'lastName' })
      if (fatherName) dispatch('SET_CONTACTS_FULL_NAME_ACTION', { value: fatherName, inputType: 'fatherName' })
      if (city?.id) commit('SET_CONTACTS_FORM', { city })
      if (email) commit('SET_CONTACTS_FORM', { email })
      if (recipientName) commit('SET_CONTACTS_FORM', { recipientName })
      if (recipientFatherName) commit('SET_CONTACTS_FORM', { recipientFatherName })
      if (recipientLastName) commit('SET_CONTACTS_FORM', { recipientLastName })
      if (recipientPhone) commit('SET_CONTACTS_FORM', { recipientPhone })
    },
    SET_INVALID_FIELDS_ACTION ({ commit }, data) {
      commit('SET_INVALID_FIELDS', data)
    },
    SET_CONTACTS_CITY_ACTION ({ commit, dispatch }, data) {
      commit('SET_CONTACTS_FORM', { city: data })
      commit('SET_INVALID_FIELDS', { city: false })
      dispatch('FETCH_DELIVERY_TYPES', data.id)
    },
    FETCH_DELIVERY_CITIES: ({ commit, rootGetters, rootState, dispatch }, city) => {
      const params = city ? { city } : {}
      commit('SET_LOADING_COMPONENTS', { selectCity: true }, { root: true })

      if (city && city.length < 2) {
        commit('SET_DELIVERY_CITIES', [])
        commit('SET_LOADING_COMPONENTS', { selectCity: false })
        return
      }
      return new Promise(resolve => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/shop/checkout/get-cities/', { params })
          .then(response => {
            const { data } = response

            commit('SET_DELIVERY_CITIES', data)

            if (data.user_delivery_city?.id) commit('SET_LAST_SELECTED_CITY', data.user_delivery_city.id)

            if (data.user_delivery_city?.id && !rootState.checkout.formData.city?.id) {
              commit('SET_CONTACTS_FORM', { city: data.user_delivery_city })
              if (window.location.pathname.includes('checkout')) {
                dispatch('FETCH_DELIVERY_TYPES', data.user_delivery_city.id)
              } else if (rootState.checkout.isManagerPage && rootState.checkout.managersClientData.city?.id) {
                commit('SET_CONTACTS_FORM', { city: rootState.checkout.managersClientData.city })
                dispatch('FETCH_DELIVERY_TYPES', rootState.checkout.managersClientData.city.id)
              }
            } else if (!rootState.checkout.formData.city?.id && rootGetters.getActualUserCity) {
              const { getActualUserCity } = rootGetters
              const id = getActualUserCity?.['city_id'] ?? ''
              const name = (rootGetters.isUkLanguage ? getActualUserCity.name_uk : getActualUserCity.name_ru) ?? ''

              if (window.location.pathname.includes('checkout') && id && name) {
                commit('SET_CONTACTS_FORM', { city: { id, name } })
                dispatch('FETCH_DELIVERY_TYPES', id)
              }
            }
            resolve(data)
          })
          .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error')))
          .finally(() => commit('SET_LOADING_COMPONENTS', { selectCity: false }))
      })
    },
    FETCH_DELIVERY_TYPES ({ commit, rootGetters, rootState, dispatch, state }, cityId) {
      commit('SET_LOADING_COMPONENTS', { deliveryForm: true })
      commit('SET_IS_FORM_HIDDEN', false)
      commit('SET_IS_FORM_SUBMITTED', false)

      const params = { cityId }

      if (rootState.checkout.isManagerPage) params.checkout_as_client = true

      return new Promise(resolve => {
        axios
          .get(rootGetters.urlLanguagePrefix + '/shop/checkout/method/', { params })
          .then(response => {
            const optionsArray = []
            // Формирует массив для отрисовки списка методов доставки
            response.data.delivery_methods.forEach((type, i) => {
              const {
                delivery_cost: deliveryCost,
                full_cost: fullCost,
                method_id: methodId,
                title,
                method_status: status,
                unavailability_reason_message: disabledInfo
              } = type
              const deliveryType = { ...rootState?.checkout?.formData?.deliveryType }

              optionsArray.push({ methodId, title, status, deliveryCost, disabledInfo, fullCost })
              commit('SET_DELIVERY_TYPES', optionsArray)

              // Подставляет значение полей доставки если есть информация по последнему заказу
              if (
                !deliveryType &&
                !rootState.deliveryForm.lastDeliveryInfo &&
                response.data.user_delivery_method &&
                methodId === response.data.user_delivery_method.id &&
                state.lastSelectedCity === cityId
              ) {
                commit('REDUCE_FORM_DATA', { deliveryType: optionsArray[i] })
                dispatch('SET_LAST_DELIVERY_INFO_ACTION', {
                  id: response.data.user_delivery_method.id,
                  ...response.data.user_delivery_method_info
                })
                dispatch('FETCH_DELIVERY_INFO', { cityId, methodId }).then(() => {
                  const storeUid = rootState?.checkout?.formData?.deliveryInfo?.deliverySpot?.uid ?? null

                  dispatch('GET_FULL_CART', {
                    notUpdateCheckout: true,
                    deliveryType: methodId,
                    storeUid
                  })
                  dispatch('FETCH_PAYMENT_TYPE', { cityId, methodId, storeUid })
                  dispatch('SUBMIT_DELIVERY')
                })
              }

              // Если условия в методе доставки изменились, меняем их на актуальные
              const formattedTypeFromServer = { methodId, title, status, deliveryCost, disabledInfo, fullCost }
              if (deliveryType?.methodId === methodId && !isEqual(deliveryType, formattedTypeFromServer)) {
                commit('REDUCE_FORM_DATA', { deliveryType: formattedTypeFromServer })
              }

              if (deliveryType?.methodId === methodId && !status) {
                // Обнуляет значение поля метода доставки если метод стал недоступным
                commit('REDUCE_FORM_DATA', { deliveryType: null, deliveryInfo: null })
              }
            })
            commit('SET_CURRENCY', response.data.currency)

            if (rootGetters.isDeliveryFormValid) dispatch('SUBMIT_DELIVERY', { root: true })

            resolve(optionsArray)
          })
          .catch(() => commit('SET_ERROR_FROM_SERVER', rootGetters.translations('server_error')))
          .finally(() => commit('SET_LOADING_COMPONENTS', { deliveryForm: false }))
      })
    },
    SET_IS_CONTACT_FORM_HIDDEN_ACTION ({ commit }, data) {
      commit('SET_IS_CONTACT_FORM_HIDDEN', data)
    },
    SET_CONTACTS_EMAIL_ACTION ({ commit }, data) {
      commit('SET_CONTACTS_FORM', { email: data })
    },
    SET_CONTACT_FORM_EMPTY_ACTION ({ commit }, bool) {
      commit('SET_CONTACT_FORM_EMPTY', bool)
    },
    SET_RECIPIENT_PHONE_ACTION ({ commit }, recipientPhone) {
      commit('SET_CONTACTS_FORM', { recipientPhone })
    },
    SET_CONTACTS_FORM_DELIVERY_TYPES ({ commit }, data) {
      commit('SET_DELIVERY_TYPES', data)
    }
  }
}
